var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDivideQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_divide_question"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24821",
    "data-name": "\\uC0AC\\uAC01\\uD615 24821",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_26452",
    "data-name": "\\uADF8\\uB8F9 26452",
    transform: "translate(-486.619 -306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_10",
    "data-name": "\\uD569\\uCE58\\uAE30 10",
    d: "M-8201.085,1320a1.384,1.384,0,0,1-1.294-1.462V1308.27a1.512,1.512,0,0,1,1.411-1.34h1.444a1.4,1.4,0,0,1,.273-.465,1.38,1.38,0,0,1,.954-.463c.052,0,.1,0,.144,0h3.7a1.364,1.364,0,0,1,1.352.927h1.524a1.507,1.507,0,0,1,1.338,1.407l0,2.441a.507.507,0,0,1-.507.506.507.507,0,0,1-.506-.506v-2.414a.474.474,0,0,0-.4-.428l-1.434,0a1.4,1.4,0,0,1-1.23.929c-.059,0-.108,0-.156,0h-3.687c-.027,0-.054,0-.078,0a1.37,1.37,0,0,1-1.274-.931h-1.43a.478.478,0,0,0-.428.406l0,10.218a.38.38,0,0,0,.346.423l1.931,0a.505.505,0,0,1,.5.506.505.505,0,0,1-.5.506h-1.854a.445.445,0,0,1-.05,0Zm2.592-12.86a.363.363,0,0,0-.092.267v.105a.368.368,0,0,0,.393.348h3.738a.39.39,0,0,0,.423-.393v-.1a.364.364,0,0,0-.394-.348h-3.819A.361.361,0,0,0-8198.493,1307.137Zm6.1,12.339a.429.429,0,0,1-.011-.6l.477-.495h-5.215a.425.425,0,0,1-.428-.426.426.426,0,0,1,.428-.428h5.215l-.477-.495a.429.429,0,0,1,.011-.6.429.429,0,0,1,.6.012l1.175,1.218a.43.43,0,0,1,0,.593l-1.175,1.218a.422.422,0,0,1-.308.132A.425.425,0,0,1-8192.394,1319.476Zm-3.884-3.3-1.173-1.218a.424.424,0,0,1,0-.593l1.173-1.218a.428.428,0,0,1,.605-.01.428.428,0,0,1,.011.6l-.478.495h5.217a.428.428,0,0,1,.428.428.427.427,0,0,1-.428.426h-5.217l.478.5a.428.428,0,0,1-.011.6.431.431,0,0,1-.3.12A.423.423,0,0,1-8196.277,1316.172Z",
    transform: "translate(8695 -995)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDivideQuestion);
export default __webpack_public_path__ + "static/media/icon_divide_question.eecf8e6f103b0dab36f4ac52092ba413.svg";
export { ForwardRef as ReactComponent };